import { z } from 'zod';

export const FloorTablePositionSchema = z.object({
  x: z.number().optional(),
  y: z.number().optional(),
  w: z.number().optional(),
  h: z.number().optional(),
});

export const FloorTableDefinitionSchema = z.object({
  id: z.string().uuid().optional(),
  label: z.string().min(1),
  capacity: z.number().int().positive(),
  zone: z.string().optional(),
  position: FloorTablePositionSchema.default({}),
  isReservable: z.boolean().default(true),
  externalRef: z.string().optional(),
});

export const FloorPlanTreePatchSchema = z.object({
  name: z.string().min(1),
  tables: z.array(FloorTableDefinitionSchema),
});

export type FloorTablePosition = z.infer<typeof FloorTablePositionSchema>;
export type FloorTableDefinition = z.infer<typeof FloorTableDefinitionSchema>;
export type FloorPlanTreePatch = z.infer<typeof FloorPlanTreePatchSchema>;

export interface FloorTableView {
  id: string;
  label: string;
  capacity: number;
  zone: string | null;
  position: FloorTablePosition;
  isReservable: boolean;
  externalRef: string | null;
}

export interface FloorPlanTreeView {
  id: string;
  name: string;
  layoutVersion: number;
  tables: FloorTableView[];
}

export function buildDefaultFloorTables(): FloorTableDefinition[] {
  return [
    { label: 'T1', capacity: 2, zone: 'Fenster', position: {}, isReservable: true },
    { label: 'T2', capacity: 4, zone: 'Hauptraum', position: {}, isReservable: true },
    { label: 'T3', capacity: 6, zone: 'Hauptraum', position: {}, isReservable: true },
    { label: 'T4', capacity: 2, zone: 'Bar', position: {}, isReservable: true },
  ];
}
